import React, { useState, useEffect } from 'react';
import './MontessoriGrid.css';
import SuperActivityService from "./Locality/Service/superActivityService";
import ActivityService from "./Locality/Service/activityService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import TeacherService from "./Locality/Service/teacherService";
import SubActivityService from "./Locality/Service/subActivityService";
import {
  Card,
  Box,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Button,
  FormControl,
  Select,
  MenuItem,
  Grid,
  Collapse,
} from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

const normalizeId = (value) => {
  if (!value) return '';
  if (typeof value === 'object' && value._id) return String(value._id);
  return String(value);
};

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#0f2d4d',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#6b7280',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#eef4ff',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  legendRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: 6,
  },
  legendItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: '0.82rem',
    color: '#46566b',
  },
  legendDot: {
    width: 14,
    height: 14,
    borderRadius: 4,
    display: 'inline-block',
  },
  filtersCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersTopRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 8,
    border: '1px solid #d9dee7',
    backgroundColor: '#f7f9fc',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#0f2d4d',
    userSelect: 'none',
  },
  countBadge: {
    backgroundColor: '#fff',
    color: '#1769d6',
    border: '1px solid #cfe0fb',
    borderRadius: 12,
    padding: '1px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    marginLeft: 8,
  },
  fieldLabel: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#46566b',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  primaryBtn: {
    backgroundColor: '#1769d6',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '8px 18px',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  outlinedBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
    border: '1px solid #d9dee7',
  },
  tabsCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
  },
  tabsScroll: {
    display: 'flex',
    gap: 8,
    overflowX: 'auto',
    paddingBottom: 4,
  },
  tabBtn: {
    padding: '8px 16px',
    borderRadius: 8,
    border: '1px solid #e6eaf0',
    backgroundColor: '#f7f9fc',
    color: '#46566b',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    fontSize: '0.88rem',
    transition: 'all 0.15s',
    '&:hover': { backgroundColor: '#eef4ff' },
  },
  tabBtnActive: {
    backgroundColor: '#1769d6',
    color: '#fff',
    border: '1px solid #1769d6',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  tableCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    overflow: 'hidden',
  },
  tableScrollHint: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      padding: theme.spacing(1, 2),
      fontSize: '0.75rem',
      color: '#7a8aa0',
      borderBottom: '1px solid #eef1f5',
    },
  },
  reportTable: {
    width: 'max-content',
    minWidth: '100%',
  },
  stickyActivityHead: {
    position: 'sticky',
    left: 0,
    zIndex: 5,
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
    borderRight: '1px solid #e6eaf0',
    minWidth: 280,
    [theme.breakpoints.down('sm')]: {
      minWidth: 132,
      maxWidth: 148,
      fontSize: '0.72rem',
      padding: '8px 6px',
    },
  },
  studentHead: {
    backgroundColor: '#f4f6fa',
    color: '#0f2d4d',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
    textAlign: 'center',
    minWidth: 58,
    maxWidth: 64,
    width: 60,
    padding: '12px 6px 10px',
    verticalAlign: 'bottom',
    [theme.breakpoints.down('sm')]: {
      minWidth: 50,
      maxWidth: 54,
      width: 52,
      padding: '10px 4px',
      fontSize: '0.74rem',
    },
  },
  studentHeadInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minHeight: 140,
    gap: 4,
  },
  studentHeadName: {
    display: 'inline-block',
    writingMode: 'vertical-rl',
    transform: 'rotate(180deg)',
    whiteSpace: 'nowrap',
    lineHeight: 1.25,
    letterSpacing: '0.04em',
    overflow: 'visible',
    color: '#0a2540',
    fontWeight: 800,
    fontSize: '0.8rem',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
  },
  stickyActivityCell: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: '#fff',
    borderRight: '1px solid #eef1f5',
    fontWeight: 600,
    color: '#0f2d4d',
    minWidth: 280,
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    verticalAlign: 'top',
    [theme.breakpoints.down('sm')]: {
      minWidth: 132,
      maxWidth: 148,
      fontSize: '0.78rem',
      padding: '8px 6px',
    },
  },
  activityGroupCell: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: '#f7f9fc',
    borderBottom: '1px solid #e6eaf0',
    borderRight: '1px solid #eef1f5',
    fontWeight: 700,
    color: '#0f2d4d',
    fontSize: '0.88rem',
    padding: '6px 12px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 132,
      maxWidth: 148,
      fontSize: '0.78rem',
      padding: '6px',
    },
  },
  activityGroupHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    userSelect: 'none',
    minWidth: 260,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      flexWrap: 'wrap',
    },
  },
  expandBtn: {
    padding: 4,
    color: '#1769d6',
  },
  exerciseCount: {
    marginLeft: 'auto',
    fontSize: '0.72rem',
    fontWeight: 600,
    color: '#7a8aa0',
    backgroundColor: '#eef4ff',
    borderRadius: 10,
    padding: '2px 8px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  studentCount: {
    flexShrink: 0,
    fontSize: '0.72rem',
    fontWeight: 600,
    color: '#1769d6',
    backgroundColor: '#eef4ff',
    borderRadius: 10,
    padding: '2px 8px',
    whiteSpace: 'nowrap',
  },
  activityGroupRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
  subActivityCell: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: '#fff',
    borderRight: '1px solid #eef1f5',
    fontWeight: 500,
    color: '#46566b',
    minWidth: 280,
    fontSize: '0.82rem',
    padding: '8px 16px 8px 32px',
    borderLeft: '3px solid #1769d6',
    [theme.breakpoints.down('sm')]: {
      minWidth: 132,
      maxWidth: 148,
      fontSize: '0.75rem',
      padding: '8px 6px 8px 12px',
    },
  },
  statusCell: {
    minWidth: 52,
    maxWidth: 56,
    width: 54,
    padding: '6px 4px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      minWidth: 44,
      maxWidth: 48,
      width: 46,
      padding: '6px 2px',
    },
  },
  statusPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 34,
    height: 26,
    padding: '0 8px',
    borderRadius: 6,
    fontWeight: 700,
    fontSize: '0.78rem',
    color: '#fff',
  },
  emptyPill: {
    color: '#c3ccd8',
    fontWeight: 700,
  },
}));

const ActivityReport = () => {
  const classes = useStyles();
  const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
  const isTeacher = userDetails.role === 'TEACHER';

  const [activityList, setActivityList] = useState([]);
  const [studentsList, setstudentsList] = useState([]);
  const [addSuperActivityList, setAddSuperActivityList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [classId, setClassId] = useState('');
  const [sectionId, setSectionId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [noteOpen, setNoteOpen] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('');
  const [teacherHasMultipleClasses, setTeacherHasMultipleClasses] = useState(false);
  const [teacherCanPickSection, setTeacherCanPickSection] = useState(true);
  const [subActivityList, setSubActivityList] = useState([]);
  const [activityCatalog, setActivityCatalog] = useState([]);
  const [expandedActivities, setExpandedActivities] = useState({});

  const colorMap = {
    P: '#17875f',
    WI: '#FF9800',
    WA: '#FFD700',
    M: '#0f2d4d',
  };

  const legend = [
    { key: 'P', label: 'Presented', color: colorMap.P },
    { key: 'WI', label: 'Working Independently', color: colorMap.WI },
    { key: 'WA', label: 'Working with Assistance', color: colorMap.WA },
    { key: 'M', label: 'Mastered', color: colorMap.M },
  ];

  const activeFilterCount = (classId ? 1 : 0) + (sectionId ? 1 : 0);

  const getActivityKey = (activity) => String(activity.id || activity._id || activity.activityName);

  const isActivityExpanded = (activity) => expandedActivities[getActivityKey(activity)] === true;

  const toggleActivityExpanded = (activity) => {
    const key = getActivityKey(activity);
    setExpandedActivities((prev) => ({
      ...prev,
      [key]: prev[key] !== true,
    }));
  };

  const expandAllActivities = () => {
    const next = {};
    activityList.forEach((activity) => {
      next[getActivityKey(activity)] = true;
    });
    setExpandedActivities(next);
  };

  const collapseAllActivities = () => {
    const next = {};
    activityList.forEach((activity) => {
      next[getActivityKey(activity)] = false;
    });
    setExpandedActivities(next);
  };

  const loadSubActivityList = async () => {
    if (!userDetails.schooleId) {
      setSubActivityList([]);
      return;
    }
    try {
      const res = await SubActivityService.getAllSubActivity(userDetails.schooleId);
      setSubActivityList(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error(err);
      setSubActivityList([]);
    }
  };

  const loadActivityCatalog = async (selectedClassId) => {
    if (!userDetails.schooleId || !selectedClassId) {
      setActivityCatalog([]);
      return [];
    }
    try {
      const res = await SuperActivityService.getAllSuperActivityTabelMultiple({
        classId: selectedClassId,
        schooleId: userDetails.schooleId,
      });
      const catalog = Array.isArray(res) ? res : [];
      setActivityCatalog(catalog);
      return catalog;
    } catch (err) {
      console.error(err);
      setActivityCatalog([]);
      return [];
    }
  };

  const getActivityTableId = (activity) => normalizeId(activity?.id || activity?._id);

  const findSubsInSuperNode = (superNode, actId, actName) => {
    if (!superNode?.activities?.length) return [];
    const catalogActivity = superNode.activities.find(
      (a) =>
        normalizeId(a._id) === actId
        || (actName && a.activityName && a.activityName.trim() === actName.trim())
    );
    if (!catalogActivity?.subActivities?.length) return [];
    const seen = new Set();
    return catalogActivity.subActivities
      .filter((sub) => sub && (sub._id || sub.subActivityName))
      .filter((sub) => {
        const key = String(sub._id || sub.subActivityName);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((sub) => ({
        id: sub._id,
        name: sub.subActivityName || 'Exercise',
        isSub: true,
      }));
  };

  const getSubActivitiesForActivity = (activity) => {
    const actId = getActivityTableId(activity);
    const actName = activity?.activityName;

    if (activityCatalog.length) {
      if (activeTab) {
        const activeSuper = activityCatalog.find(
          (node) => normalizeId(node._id) === normalizeId(activeTab)
        );
        const fromActiveTab = findSubsInSuperNode(activeSuper, actId, actName);
        if (fromActiveTab.length) return fromActiveTab;
      }

      for (const superNode of activityCatalog) {
        const fromNode = findSubsInSuperNode(superNode, actId, actName);
        if (fromNode.length) return fromNode;
      }
    }

    const masterList = subActivityList.filter((item) => {
      const parentId = normalizeId(item?.activityId?._id || item?.activityId);
      return parentId === actId;
    });
    if (masterList.length > 0) {
      return masterList.map((item) => ({
        id: item._id,
        name: item.subActivityName,
        isSub: true,
      }));
    }

    return [];
  };

  const findStudentRecord = (activity, studentId, subActivityId = null) => {
    return (activity.activityList || []).find((entry) => {
      const entryStudentId = normalizeId(entry?.studentId?._id || entry?.studentId);
      if (entryStudentId !== normalizeId(studentId)) return false;

      const recordSub = entry?.activityRecordsId?.[0]?.subActivityId;
      const recordSubId = recordSub?._id || recordSub || null;

      if (subActivityId) {
        return String(recordSubId) === String(subActivityId);
      }
      return !recordSubId;
    });
  };

  const getExerciseRows = (activity) => {
    const subRows = getSubActivitiesForActivity(activity);
    if (subRows.length > 0) {
      return subRows;
    }

    const fromRecords = new Map();
    (activity.activityList || []).forEach((entry) => {
      const sub = entry?.activityRecordsId?.[0]?.subActivityId;
      if (sub) {
        const id = sub._id || sub;
        if (!fromRecords.has(String(id))) {
          fromRecords.set(String(id), {
            id,
            name: sub.subActivityName || 'Exercise',
            isSub: true,
          });
        }
      }
    });

    if (fromRecords.size > 0) {
      return Array.from(fromRecords.values());
    }

    return [{ id: null, name: null, isSub: false }];
  };

  const getStudentsPerformedCount = (activity) => {
    const studentIds = new Set();
    (activity.activityList || []).forEach((entry) => {
      const studentId = normalizeId(entry?.studentId?._id || entry?.studentId);
      if (!studentId) return;
      const hasStatus = Boolean(entry?.activityRecordsId?.[0]?.key);
      if (hasStatus) {
        studentIds.add(studentId);
      }
    });
    return studentIds.size;
  };

  const hasExpandableActivities = activityList.some((activity) => {
    const rows = getExerciseRows(activity);
    return rows.some((row) => row.isSub && row.id);
  });

  const renderStatusCell = (activity, student, subActivityId) => {
    const record = findStudentRecord(activity, student._id, subActivityId);
    const key = record?.activityRecordsId?.[0]?.key;
    const bgColor = colorMap[key];

    return (
      <TableCell key={student._id} align="center" title={key || ''} className={classes.statusCell}>
        {key ? (
          <span className={classes.statusPill} style={{ backgroundColor: bgColor || '#9aa7b8' }}>
            {key}
          </span>
        ) : (
          <span className={classes.emptyPill}>—</span>
        )}
      </TableCell>
    );
  };

  const renderActivityRows = (activity) => {
    const exerciseRows = getExerciseRows(activity);
    const hasSubRows = exerciseRows.some((row) => row.isSub && row.id);
    const expanded = isActivityExpanded(activity);
    const studentsPerformedCount = getStudentsPerformedCount(activity);

    if (!hasSubRows) {
      return [
        <TableRow key={activity.id || activity._id || activity.activityName} hover>
          <TableCell className={classes.stickyActivityCell}>
            {activity.activityName}
          </TableCell>
          {studentsList.map((student) => renderStatusCell(activity, student, null))}
        </TableRow>,
      ];
    }

    const rows = [
      <TableRow key={`${activity.id}-header`} className={classes.activityGroupRow} hover>
        <TableCell className={classes.activityGroupCell}>
          <Box
            className={classes.activityGroupHeader}
            onClick={() => toggleActivityExpanded(activity)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleActivityExpanded(activity);
              }
            }}
          >
            <IconButton
              size="small"
              className={classes.expandBtn}
              aria-label={expanded ? 'Collapse exercises' : 'Expand exercises'}
              onClick={(e) => {
                e.stopPropagation();
                toggleActivityExpanded(activity);
              }}
            >
              {expanded ? (
                <ExpandMoreIcon style={{ fontSize: 20 }} />
              ) : (
                <ChevronRightIcon style={{ fontSize: 20 }} />
              )}
            </IconButton>
            <span>{activity.activityName}</span>
            <span className={classes.studentCount}>
              {studentsPerformedCount} student{studentsPerformedCount !== 1 ? 's' : ''}
            </span>
          </Box>
        </TableCell>
        {studentsList.map((student) => (
          <TableCell
            key={`${activity.id}-pad-${student._id}`}
            className={classes.statusCell}
            style={{ backgroundColor: '#f7f9fc' }}
          />
        ))}
      </TableRow>,
    ];

    if (expanded) {
      exerciseRows.forEach((exercise, index) => {
        rows.push(
          <TableRow key={`${activity.id}-${exercise.id || index}`} hover>
            <TableCell className={classes.subActivityCell}>
              {exercise.name}
            </TableCell>
            {studentsList.map((student) => renderStatusCell(activity, student, exercise.id))}
          </TableRow>
        );
      });
    }

    return rows;
  };

  const loadReport = (superActivityId, sectionIdOverride) => {
    if (!superActivityId || !classId) return;

    setIsLoading(true);
    const effectiveSectionId =
      sectionIdOverride !== undefined
        ? sectionIdOverride
        : (sectionId || normalizeId(userDetails.sectionId) || '');

    const keys = {
      schooleId: userDetails.schooleId,
      isFuturePlanning: false,
      isInitLoad: true,
      superActivityId,
      studentId: '',
      classId,
      sectionId: effectiveSectionId || undefined,
      startDate: '',
      endDate: '',
      status: true,
    };

    ActivityService.findActivityReports(keys)
      .then((result) => {
        setActivityList(Array.isArray(result) ? result : []);
        const allStudents = [];
        (Array.isArray(result) ? result : []).forEach((activity) =>
          (activity.activityList || []).forEach((rec) => {
            const student = rec.studentId;
            if (student && !allStudents.find((s) => s._id === student._id)) {
              allStudents.push(student);
            }
          })
        );
        setstudentsList(allStudents);
      })
      .catch((err) => {
        console.error(err);
        setActivityList([]);
        setstudentsList([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getSectionListByClass = (selectedClassId) => {
    if (!selectedClassId) {
      setSectionList([]);
      setTeacherCanPickSection(false);
      return Promise.resolve([]);
    }

    const body = {
      schooleId: userDetails.schooleId,
      classId: selectedClassId,
    };
    if (isTeacher && userDetails.teacherId) {
      body.teacherId = userDetails.teacherId;
    }

    return SectionService.findSectionList(body)
      .then((res) => {
        const rows = Array.isArray(res) ? res : [];
        setSectionList(rows);
        if (isTeacher) {
          setTeacherCanPickSection(rows.length > 1);
        }
        return rows;
      })
      .catch(() => {
        setSectionList([]);
        return [];
      });
  };

  const loadSuperActivitiesForClass = async (selectedClassId, sectionIdOverride) => {
    if (!selectedClassId) {
      setAddSuperActivityList([]);
      setActiveTab('');
      setActivityList([]);
      setstudentsList([]);
      setSubActivityList([]);
      setActivityCatalog([]);
      return;
    }

    await Promise.all([
      loadActivityCatalog(selectedClassId),
      loadSubActivityList(),
    ]);

    try {
      const res = await SuperActivityService.getAllSuperActivityById(
        userDetails.schooleId,
        { classId: selectedClassId }
      );
      const filtered = (Array.isArray(res) ? res : []).filter(
        (item) => normalizeId(item.classId?._id || item.classId) === normalizeId(selectedClassId)
      );
      setAddSuperActivityList(filtered);
      if (filtered.length > 0) {
        setActiveTab(filtered[0]._id);
        loadReport(filtered[0]._id, sectionIdOverride);
      } else {
        setActiveTab('');
        setActivityList([]);
        setstudentsList([]);
      }
    } catch (err) {
      console.error(err);
      setAddSuperActivityList([]);
      setActiveTab('');
      setActivityList([]);
      setstudentsList([]);
    }
  };

  const applyClassSection = (selectedClassId, preferredSectionId) => {
    const cid = normalizeId(selectedClassId);
    if (!cid) return Promise.resolve();
    setClassId(cid);
    return getSectionListByClass(cid).then((rows) => {
      let validSection = '';
      if (rows.length === 1) {
        validSection = normalizeId(rows[0]._id);
      } else if (
        preferredSectionId &&
        rows.some((s) => normalizeId(s._id) === normalizeId(preferredSectionId))
      ) {
        validSection = normalizeId(preferredSectionId);
      }
      setSectionId(validSection);
      return loadSuperActivitiesForClass(cid, validSection);
    });
  };

  const syncTeacherProfile = () => {
    const storedClassId = normalizeId(userDetails.classId);
    const storedSectionId = normalizeId(userDetails.sectionId);

    if (!userDetails.teacherId) {
      if (storedClassId) return applyClassSection(storedClassId, storedSectionId);
      return Promise.resolve();
    }

    return TeacherService.getTeacherById(userDetails.teacherId)
      .then((teacher) => {
        const classIds = new Set();
        const primaryClassId = normalizeId(teacher?.classId?._id || teacher?.classId);
        if (primaryClassId) classIds.add(primaryClassId);
        (teacher?.additionalClassAndSection || []).forEach((item) => {
          const cid = normalizeId(item?.class?.classId?._id || item?.class?.classId);
          if (cid) classIds.add(cid);
        });
        setTeacherHasMultipleClasses(classIds.size > 1);

        const freshClassId = primaryClassId || storedClassId;
        const freshSectionId =
          normalizeId(teacher?.sectionId?._id || teacher?.sectionId) || storedSectionId;
        return applyClassSection(freshClassId, freshSectionId);
      })
      .catch(() => {
        setTeacherHasMultipleClasses(false);
        if (storedClassId) return applyClassSection(storedClassId, storedSectionId);
        return Promise.resolve();
      });
  };

  const getAddClassList = () => {
    AddClassService.getAllAddClass(
      userDetails.schooleId,
      isTeacher ? 'TEACHER' : undefined,
      true
    )
      .then((res) => {
        const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        setAddClassList(list);
        if (isTeacher) {
          return syncTeacherProfile();
        }
        if (list.length > 0) {
          const defaultClassId = list[0]._id;
          setClassId(defaultClassId);
          setSectionId('');
          getSectionListByClass(defaultClassId);
          loadSuperActivitiesForClass(defaultClassId, '');
        }
        return Promise.resolve();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getAddClassList();
    return () => {
      setAddSuperActivityList([]);
      setActivityList([]);
      setstudentsList([]);
    };
  }, []);

  useEffect(() => {
    setExpandedActivities({});
  }, [activeTab]);

  const handleClassChange = (e) => {
    const selectedClassId = e.target.value;
    setClassId(selectedClassId);
    setSectionId('');
    if (selectedClassId) {
      getSectionListByClass(selectedClassId).then((rows) => {
        let sid = '';
        if (rows.length === 1) sid = normalizeId(rows[0]._id);
        setSectionId(sid);
        loadSuperActivitiesForClass(selectedClassId, sid);
      });
    } else {
      setSectionList([]);
      setAddSuperActivityList([]);
      setActiveTab('');
      setActivityList([]);
      setstudentsList([]);
    }
  };

  const handleSectionChange = (e) => {
    const newSectionId = e.target.value;
    setSectionId(newSectionId);
    if (activeTab) {
      loadReport(activeTab, newSectionId);
    }
  };

  const handleResetFilters = () => {
    if (isTeacher) {
      syncTeacherProfile();
      return;
    }
    if (addClassList.length > 0) {
      const defaultClassId = addClassList[0]._id;
      setClassId(defaultClassId);
      setSectionId('');
      getSectionListByClass(defaultClassId);
      loadSuperActivitiesForClass(defaultClassId, '');
    }
  };

  const handleSearch = () => {
    if (activeTab) {
      loadReport(activeTab);
    } else if (classId) {
      loadSuperActivitiesForClass(classId, sectionId);
    }
  };

  const handleTabClick = (superActivityId) => {
    setActiveTab(superActivityId);
    loadReport(superActivityId);
  };

  return (
    <Box p={{ xs: 1, sm: 2 }}>
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Activity Status</Typography>
          <Typography className={classes.pageSubtitle}>
            Track each student's progress across activities by area of work.
          </Typography>
        </Box>
      </Box>

      {noteOpen && (
        <Box className={classes.noteBanner}>
          <Box className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </Box>
          <Box flex={1}>
            <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>
              How to read this report
            </Typography>
            <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2 }}>
              Select class and section, then pick an area of work. Activities with exercises show sub-rows indented under the parent activity.
            </Typography>
            <Box className={classes.legendRow}>
              {legend.map((l) => (
                <span key={l.key} className={classes.legendItem}>
                  <span className={classes.legendDot} style={{ backgroundColor: l.color }} />
                  <strong style={{ color: '#0f2d4d' }}>{l.key}</strong> {l.label}
                </span>
              ))}
            </Box>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)}>
            <CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} />
          </IconButton>
        </Box>
      )}

      <Card className={classes.filtersCard} elevation={0}>
        <Box className={classes.filtersTopRow}>
          <Box
            className={classes.filtersChip}
            onClick={() => setFiltersOpen((o) => !o)}
            role="button"
            tabIndex={0}
          >
            <FilterListIcon fontSize="small" />
            <span>Filters</span>
            <span className={classes.countBadge}>{activeFilterCount}</span>
            {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
          </Box>
        </Box>

        <Collapse in={filtersOpen}>
          <Box mt={2}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={6} md={4}>
                <Typography className={classes.fieldLabel}>
                  <SchoolIcon style={{ fontSize: 16 }} /> Class
                </Typography>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    displayEmpty
                    value={classId}
                    onChange={handleClassChange}
                    disabled={isTeacher && !teacherHasMultipleClasses}
                  >
                    {!isTeacher && <MenuItem value=""><em>Select Class</em></MenuItem>}
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography className={classes.fieldLabel}>
                  <PersonIcon style={{ fontSize: 16 }} /> Section
                </Typography>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  disabled={!classId || sectionList.length === 0 || (isTeacher && !teacherCanPickSection)}
                >
                  <Select displayEmpty value={sectionId} onChange={handleSectionChange}>
                    <MenuItem value=""><em>All Sections</em></MenuItem>
                    {sectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Box display="flex" justifyContent="flex-end" gridGap={10}>
                  <Button className={classes.outlinedBtn} variant="outlined" onClick={handleResetFilters}>
                    Reset
                  </Button>
                  <Button
                    className={classes.primaryBtn}
                    variant="contained"
                    startIcon={<SearchIcon />}
                    onClick={handleSearch}
                    disabled={!classId}
                  >
                    Search
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </Card>

      <Card className={classes.tabsCard}>
        <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.95rem', marginBottom: 10 }}>
          Area Of Work
        </Typography>
        <Box className={classes.tabsScroll}>
          {addSuperActivityList.length === 0 ? (
            <Typography variant="body2" style={{ color: '#7a8aa0', padding: '4px 0' }}>
              {classId ? 'No areas of work for this class.' : 'Select a class to view areas of work.'}
            </Typography>
          ) : (
            addSuperActivityList.map((area) => {
              const isActive = activeTab === area._id;
              return (
                <button
                  key={area._id}
                  type="button"
                  onClick={() => handleTabClick(area._id)}
                  className={`${classes.tabBtn} ${isActive ? classes.tabBtnActive : ''}`}
                >
                  {area.superActivityName}
                </button>
              );
            })
          )}
        </Box>
      </Card>

      {isLoading ? (
        <Box display="flex" alignItems="center" justifyContent="center" py={6} style={{ gap: 12 }}>
          <CircularProgress size={26} />
          <Typography style={{ color: '#1769d6', fontWeight: 600 }}>Loading data...</Typography>
        </Box>
      ) : (
        <Card className={classes.tableCard}>
          {hasExpandableActivities && (
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              gridGap={8}
              px={2}
              py={1}
              style={{ borderBottom: '1px solid #eef1f5' }}
            >
              <Button size="small" className={classes.outlinedBtn} onClick={expandAllActivities}>
                Expand all
              </Button>
              <Button size="small" className={classes.outlinedBtn} onClick={collapseAllActivities}>
                Collapse all
              </Button>
            </Box>
          )}
          {studentsList.length > 0 && (
            <Typography className={classes.tableScrollHint}>
              Swipe sideways to see student names and status.
            </Typography>
          )}
          <TableContainer
            component={Paper}
            elevation={0}
            style={{ maxHeight: '70vh', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}
          >
            <Table
              stickyHeader
              size="small"
              className={classes.reportTable}
              style={{
                minWidth: Math.max(
                  360,
                  (typeof window !== 'undefined' && window.innerWidth < 600 ? 140 : 280)
                    + Math.max(studentsList.length, 1)
                      * (typeof window !== 'undefined' && window.innerWidth < 600 ? 82 : 100)
                ),
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell className={classes.stickyActivityHead}>Activity</TableCell>
                  {studentsList.map((student) => {
                    const fullName = `${student.firstName || ''} ${student.lastName || ''}`.trim();
                    return (
                      <TableCell key={student._id} className={classes.studentHead} title={fullName}>
                        <Box className={classes.studentHeadInner}>
                          <span className={classes.studentHeadName}>
                            {fullName ? fullName.toUpperCase() : 'STUDENT'}
                          </span>
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {activityList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={studentsList.length + 1} align="center" style={{ padding: 32, color: '#7a8aa0' }}>
                      No activity records found for this area.
                    </TableCell>
                  </TableRow>
                ) : (
                  activityList.flatMap((activity) => renderActivityRows(activity))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}
    </Box>
  );
};

export default ActivityReport;
